function Ut(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Ae = { exports: {} }, Pt = function(e, r) {
  return function() {
    for (var s = new Array(arguments.length), a = 0; a < s.length; a++)
      s[a] = arguments[a];
    return e.apply(r, s);
  };
}, lr = Pt, Le = Object.prototype.toString, Se = /* @__PURE__ */ function(t) {
  return function(e) {
    var r = Le.call(e);
    return t[r] || (t[r] = r.slice(8, -1).toLowerCase());
  };
}(/* @__PURE__ */ Object.create(null));
function x(t) {
  return t = t.toLowerCase(), function(r) {
    return Se(r) === t;
  };
}
function De(t) {
  return Array.isArray(t);
}
function se(t) {
  return typeof t > "u";
}
function dr(t) {
  return t !== null && !se(t) && t.constructor !== null && !se(t.constructor) && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
}
var Bt = x("ArrayBuffer");
function hr(t) {
  var e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && Bt(t.buffer), e;
}
function fr(t) {
  return typeof t == "string";
}
function pr(t) {
  return typeof t == "number";
}
function Nt(t) {
  return t !== null && typeof t == "object";
}
function te(t) {
  if (Se(t) !== "object")
    return !1;
  var e = Object.getPrototypeOf(t);
  return e === null || e === Object.prototype;
}
var mr = x("Date"), yr = x("File"), _r = x("Blob"), vr = x("FileList");
function $e(t) {
  return Le.call(t) === "[object Function]";
}
function Er(t) {
  return Nt(t) && $e(t.pipe);
}
function Rr(t) {
  var e = "[object FormData]";
  return t && (typeof FormData == "function" && t instanceof FormData || Le.call(t) === e || $e(t.toString) && t.toString() === e);
}
var gr = x("URLSearchParams");
function Cr(t) {
  return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
}
function wr() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function xe(t, e) {
  if (!(t === null || typeof t > "u"))
    if (typeof t != "object" && (t = [t]), De(t))
      for (var r = 0, n = t.length; r < n; r++)
        e.call(null, t[r], r, t);
    else
      for (var s in t)
        Object.prototype.hasOwnProperty.call(t, s) && e.call(null, t[s], s, t);
}
function Pe() {
  var t = {};
  function e(s, a) {
    te(t[a]) && te(s) ? t[a] = Pe(t[a], s) : te(s) ? t[a] = Pe({}, s) : De(s) ? t[a] = s.slice() : t[a] = s;
  }
  for (var r = 0, n = arguments.length; r < n; r++)
    xe(arguments[r], e);
  return t;
}
function Or(t, e, r) {
  return xe(e, function(s, a) {
    r && typeof s == "function" ? t[a] = lr(s, r) : t[a] = s;
  }), t;
}
function Ir(t) {
  return t.charCodeAt(0) === 65279 && (t = t.slice(1)), t;
}
function br(t, e, r, n) {
  t.prototype = Object.create(e.prototype, n), t.prototype.constructor = t, r && Object.assign(t.prototype, r);
}
function Tr(t, e, r) {
  var n, s, a, i = {};
  e = e || {};
  do {
    for (n = Object.getOwnPropertyNames(t), s = n.length; s-- > 0; )
      a = n[s], i[a] || (e[a] = t[a], i[a] = !0);
    t = Object.getPrototypeOf(t);
  } while (t && (!r || r(t, e)) && t !== Object.prototype);
  return e;
}
function Ur(t, e, r) {
  t = String(t), (r === void 0 || r > t.length) && (r = t.length), r -= e.length;
  var n = t.indexOf(e, r);
  return n !== -1 && n === r;
}
function Pr(t) {
  if (!t) return null;
  var e = t.length;
  if (se(e)) return null;
  for (var r = new Array(e); e-- > 0; )
    r[e] = t[e];
  return r;
}
var Br = /* @__PURE__ */ function(t) {
  return function(e) {
    return t && e instanceof t;
  };
}(typeof Uint8Array < "u" && Object.getPrototypeOf(Uint8Array)), g = {
  isArray: De,
  isArrayBuffer: Bt,
  isBuffer: dr,
  isFormData: Rr,
  isArrayBufferView: hr,
  isString: fr,
  isNumber: pr,
  isObject: Nt,
  isPlainObject: te,
  isUndefined: se,
  isDate: mr,
  isFile: yr,
  isBlob: _r,
  isFunction: $e,
  isStream: Er,
  isURLSearchParams: gr,
  isStandardBrowserEnv: wr,
  forEach: xe,
  merge: Pe,
  extend: Or,
  trim: Cr,
  stripBOM: Ir,
  inherits: br,
  toFlatObject: Tr,
  kindOf: Se,
  kindOfTest: x,
  endsWith: Ur,
  toArray: Pr,
  isTypedArray: Br,
  isFileList: vr
}, q = g;
function ze(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var At = function(e, r, n) {
  if (!r)
    return e;
  var s;
  if (n)
    s = n(r);
  else if (q.isURLSearchParams(r))
    s = r.toString();
  else {
    var a = [];
    q.forEach(r, function(u, f) {
      u === null || typeof u > "u" || (q.isArray(u) ? f = f + "[]" : u = [u], q.forEach(u, function(y) {
        q.isDate(y) ? y = y.toISOString() : q.isObject(y) && (y = JSON.stringify(y)), a.push(ze(f) + "=" + ze(y));
      }));
    }), s = a.join("&");
  }
  if (s) {
    var i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}, Nr = g;
function ie() {
  this.handlers = [];
}
ie.prototype.use = function(e, r, n) {
  return this.handlers.push({
    fulfilled: e,
    rejected: r,
    synchronous: n ? n.synchronous : !1,
    runWhen: n ? n.runWhen : null
  }), this.handlers.length - 1;
};
ie.prototype.eject = function(e) {
  this.handlers[e] && (this.handlers[e] = null);
};
ie.prototype.forEach = function(e) {
  Nr.forEach(this.handlers, function(n) {
    n !== null && e(n);
  });
};
var Ar = ie, Lr = g, Sr = function(e, r) {
  Lr.forEach(e, function(s, a) {
    a !== r && a.toUpperCase() === r.toUpperCase() && (e[r] = s, delete e[a]);
  });
}, Lt = g;
function W(t, e, r, n, s) {
  Error.call(this), this.message = t, this.name = "AxiosError", e && (this.code = e), r && (this.config = r), n && (this.request = n), s && (this.response = s);
}
Lt.inherits(W, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
var St = W.prototype, Dt = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED"
  // eslint-disable-next-line func-names
].forEach(function(t) {
  Dt[t] = { value: t };
});
Object.defineProperties(W, Dt);
Object.defineProperty(St, "isAxiosError", { value: !0 });
W.from = function(t, e, r, n, s, a) {
  var i = Object.create(St);
  return Lt.toFlatObject(t, i, function(u) {
    return u !== Error.prototype;
  }), W.call(i, t.message, e, r, n, s), i.name = t.name, a && Object.assign(i, a), i;
};
var z = W, $t = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, b = g;
function Dr(t, e) {
  e = e || new FormData();
  var r = [];
  function n(a) {
    return a === null ? "" : b.isDate(a) ? a.toISOString() : b.isArrayBuffer(a) || b.isTypedArray(a) ? typeof Blob == "function" ? new Blob([a]) : Buffer.from(a) : a;
  }
  function s(a, i) {
    if (b.isPlainObject(a) || b.isArray(a)) {
      if (r.indexOf(a) !== -1)
        throw Error("Circular reference detected in " + i);
      r.push(a), b.forEach(a, function(u, f) {
        if (!b.isUndefined(u)) {
          var l = i ? i + "." + f : f, y;
          if (u && !i && typeof u == "object") {
            if (b.endsWith(f, "{}"))
              u = JSON.stringify(u);
            else if (b.endsWith(f, "[]") && (y = b.toArray(u))) {
              y.forEach(function(c) {
                !b.isUndefined(c) && e.append(l, n(c));
              });
              return;
            }
          }
          s(u, l);
        }
      }), r.pop();
    } else
      e.append(i, n(a));
  }
  return s(t), e;
}
var xt = Dr, fe, Je;
function $r() {
  if (Je) return fe;
  Je = 1;
  var t = z;
  return fe = function(r, n, s) {
    var a = s.config.validateStatus;
    !s.status || !a || a(s.status) ? r(s) : n(new t(
      "Request failed with status code " + s.status,
      [t.ERR_BAD_REQUEST, t.ERR_BAD_RESPONSE][Math.floor(s.status / 100) - 4],
      s.config,
      s.request,
      s
    ));
  }, fe;
}
var pe, Ke;
function xr() {
  if (Ke) return pe;
  Ke = 1;
  var t = g;
  return pe = t.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    /* @__PURE__ */ function() {
      return {
        write: function(n, s, a, i, o, u) {
          var f = [];
          f.push(n + "=" + encodeURIComponent(s)), t.isNumber(a) && f.push("expires=" + new Date(a).toGMTString()), t.isString(i) && f.push("path=" + i), t.isString(o) && f.push("domain=" + o), u === !0 && f.push("secure"), document.cookie = f.join("; ");
        },
        read: function(n) {
          var s = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
          return s ? decodeURIComponent(s[3]) : null;
        },
        remove: function(n) {
          this.write(n, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), pe;
}
var kr = function(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}, jr = function(e, r) {
  return r ? e.replace(/\/+$/, "") + "/" + r.replace(/^\/+/, "") : e;
}, Fr = kr, Vr = jr, kt = function(e, r) {
  return e && !Fr(r) ? Vr(e, r) : r;
}, me, Xe;
function qr() {
  if (Xe) return me;
  Xe = 1;
  var t = g, e = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return me = function(n) {
    var s = {}, a, i, o;
    return n && t.forEach(n.split(`
`), function(f) {
      if (o = f.indexOf(":"), a = t.trim(f.substr(0, o)).toLowerCase(), i = t.trim(f.substr(o + 1)), a) {
        if (s[a] && e.indexOf(a) >= 0)
          return;
        a === "set-cookie" ? s[a] = (s[a] ? s[a] : []).concat([i]) : s[a] = s[a] ? s[a] + ", " + i : i;
      }
    }), s;
  }, me;
}
var ye, Qe;
function Gr() {
  if (Qe) return ye;
  Qe = 1;
  var t = g;
  return ye = t.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var r = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a"), s;
      function a(i) {
        var o = i;
        return r && (n.setAttribute("href", o), o = n.href), n.setAttribute("href", o), {
          href: n.href,
          protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
          host: n.host,
          search: n.search ? n.search.replace(/^\?/, "") : "",
          hash: n.hash ? n.hash.replace(/^#/, "") : "",
          hostname: n.hostname,
          port: n.port,
          pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
        };
      }
      return s = a(window.location.href), function(o) {
        var u = t.isString(o) ? a(o) : o;
        return u.protocol === s.protocol && u.host === s.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    /* @__PURE__ */ function() {
      return function() {
        return !0;
      };
    }()
  ), ye;
}
var _e, Ze;
function oe() {
  if (Ze) return _e;
  Ze = 1;
  var t = z, e = g;
  function r(n) {
    t.call(this, n ?? "canceled", t.ERR_CANCELED), this.name = "CanceledError";
  }
  return e.inherits(r, t, {
    __CANCEL__: !0
  }), _e = r, _e;
}
var ve, et;
function Mr() {
  return et || (et = 1, ve = function(e) {
    var r = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
    return r && r[1] || "";
  }), ve;
}
var Ee, tt;
function rt() {
  if (tt) return Ee;
  tt = 1;
  var t = g, e = $r(), r = xr(), n = At, s = kt, a = qr(), i = Gr(), o = $t, u = z, f = oe(), l = Mr();
  return Ee = function(c) {
    return new Promise(function(J, j) {
      var K = c.data, X = c.headers, Q = c.responseType, F;
      function He() {
        c.cancelToken && c.cancelToken.unsubscribe(F), c.signal && c.signal.removeEventListener("abort", F);
      }
      t.isFormData(K) && t.isStandardBrowserEnv() && delete X["Content-Type"];
      var p = new XMLHttpRequest();
      if (c.auth) {
        var or = c.auth.username || "", ur = c.auth.password ? unescape(encodeURIComponent(c.auth.password)) : "";
        X.Authorization = "Basic " + btoa(or + ":" + ur);
      }
      var le = s(c.baseURL, c.url);
      p.open(c.method.toUpperCase(), n(le, c.params, c.paramsSerializer), !0), p.timeout = c.timeout;
      function We() {
        if (p) {
          var I = "getAllResponseHeaders" in p ? a(p.getAllResponseHeaders()) : null, V = !Q || Q === "text" || Q === "json" ? p.responseText : p.response, L = {
            data: V,
            status: p.status,
            statusText: p.statusText,
            headers: I,
            config: c,
            request: p
          };
          e(function(he) {
            J(he), He();
          }, function(he) {
            j(he), He();
          }, L), p = null;
        }
      }
      if ("onloadend" in p ? p.onloadend = We : p.onreadystatechange = function() {
        !p || p.readyState !== 4 || p.status === 0 && !(p.responseURL && p.responseURL.indexOf("file:") === 0) || setTimeout(We);
      }, p.onabort = function() {
        p && (j(new u("Request aborted", u.ECONNABORTED, c, p)), p = null);
      }, p.onerror = function() {
        j(new u("Network Error", u.ERR_NETWORK, c, p, p)), p = null;
      }, p.ontimeout = function() {
        var V = c.timeout ? "timeout of " + c.timeout + "ms exceeded" : "timeout exceeded", L = c.transitional || o;
        c.timeoutErrorMessage && (V = c.timeoutErrorMessage), j(new u(
          V,
          L.clarifyTimeoutError ? u.ETIMEDOUT : u.ECONNABORTED,
          c,
          p
        )), p = null;
      }, t.isStandardBrowserEnv()) {
        var Ye = (c.withCredentials || i(le)) && c.xsrfCookieName ? r.read(c.xsrfCookieName) : void 0;
        Ye && (X[c.xsrfHeaderName] = Ye);
      }
      "setRequestHeader" in p && t.forEach(X, function(V, L) {
        typeof K > "u" && L.toLowerCase() === "content-type" ? delete X[L] : p.setRequestHeader(L, V);
      }), t.isUndefined(c.withCredentials) || (p.withCredentials = !!c.withCredentials), Q && Q !== "json" && (p.responseType = c.responseType), typeof c.onDownloadProgress == "function" && p.addEventListener("progress", c.onDownloadProgress), typeof c.onUploadProgress == "function" && p.upload && p.upload.addEventListener("progress", c.onUploadProgress), (c.cancelToken || c.signal) && (F = function(I) {
        p && (j(!I || I && I.type ? new f() : I), p.abort(), p = null);
      }, c.cancelToken && c.cancelToken.subscribe(F), c.signal && (c.signal.aborted ? F() : c.signal.addEventListener("abort", F))), K || (K = null);
      var de = l(le);
      if (de && ["http", "https", "file"].indexOf(de) === -1) {
        j(new u("Unsupported protocol " + de + ":", u.ERR_BAD_REQUEST, c));
        return;
      }
      p.send(K);
    });
  }, Ee;
}
var Re, nt;
function Hr() {
  return nt || (nt = 1, Re = null), Re;
}
var E = g, st = Sr, at = z, Wr = $t, Yr = xt, zr = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function it(t, e) {
  !E.isUndefined(t) && E.isUndefined(t["Content-Type"]) && (t["Content-Type"] = e);
}
function Jr() {
  var t;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (t = rt()), t;
}
function Kr(t, e, r) {
  if (E.isString(t))
    try {
      return (e || JSON.parse)(t), E.trim(t);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (0, JSON.stringify)(t);
}
var ue = {
  transitional: Wr,
  adapter: Jr(),
  transformRequest: [function(e, r) {
    if (st(r, "Accept"), st(r, "Content-Type"), E.isFormData(e) || E.isArrayBuffer(e) || E.isBuffer(e) || E.isStream(e) || E.isFile(e) || E.isBlob(e))
      return e;
    if (E.isArrayBufferView(e))
      return e.buffer;
    if (E.isURLSearchParams(e))
      return it(r, "application/x-www-form-urlencoded;charset=utf-8"), e.toString();
    var n = E.isObject(e), s = r && r["Content-Type"], a;
    if ((a = E.isFileList(e)) || n && s === "multipart/form-data") {
      var i = this.env && this.env.FormData;
      return Yr(a ? { "files[]": e } : e, i && new i());
    } else if (n || s === "application/json")
      return it(r, "application/json"), Kr(e);
    return e;
  }],
  transformResponse: [function(e) {
    var r = this.transitional || ue.transitional, n = r && r.silentJSONParsing, s = r && r.forcedJSONParsing, a = !n && this.responseType === "json";
    if (a || s && E.isString(e) && e.length)
      try {
        return JSON.parse(e);
      } catch (i) {
        if (a)
          throw i.name === "SyntaxError" ? at.from(i, at.ERR_BAD_RESPONSE, this, null, this.response) : i;
      }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Hr()
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
E.forEach(["delete", "get", "head"], function(e) {
  ue.headers[e] = {};
});
E.forEach(["post", "put", "patch"], function(e) {
  ue.headers[e] = E.merge(zr);
});
var ke = ue, Xr = g, Qr = ke, Zr = function(e, r, n) {
  var s = this || Qr;
  return Xr.forEach(n, function(i) {
    e = i.call(s, e, r);
  }), e;
}, ge, ot;
function jt() {
  return ot || (ot = 1, ge = function(e) {
    return !!(e && e.__CANCEL__);
  }), ge;
}
var ut = g, Ce = Zr, en = jt(), tn = ke, rn = oe();
function we(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new rn();
}
var nn = function(e) {
  we(e), e.headers = e.headers || {}, e.data = Ce.call(
    e,
    e.data,
    e.headers,
    e.transformRequest
  ), e.headers = ut.merge(
    e.headers.common || {},
    e.headers[e.method] || {},
    e.headers
  ), ut.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(s) {
      delete e.headers[s];
    }
  );
  var r = e.adapter || tn.adapter;
  return r(e).then(function(s) {
    return we(e), s.data = Ce.call(
      e,
      s.data,
      s.headers,
      e.transformResponse
    ), s;
  }, function(s) {
    return en(s) || (we(e), s && s.response && (s.response.data = Ce.call(
      e,
      s.response.data,
      s.response.headers,
      e.transformResponse
    ))), Promise.reject(s);
  });
}, O = g, Ft = function(e, r) {
  r = r || {};
  var n = {};
  function s(l, y) {
    return O.isPlainObject(l) && O.isPlainObject(y) ? O.merge(l, y) : O.isPlainObject(y) ? O.merge({}, y) : O.isArray(y) ? y.slice() : y;
  }
  function a(l) {
    if (O.isUndefined(r[l])) {
      if (!O.isUndefined(e[l]))
        return s(void 0, e[l]);
    } else return s(e[l], r[l]);
  }
  function i(l) {
    if (!O.isUndefined(r[l]))
      return s(void 0, r[l]);
  }
  function o(l) {
    if (O.isUndefined(r[l])) {
      if (!O.isUndefined(e[l]))
        return s(void 0, e[l]);
    } else return s(void 0, r[l]);
  }
  function u(l) {
    if (l in r)
      return s(e[l], r[l]);
    if (l in e)
      return s(void 0, e[l]);
  }
  var f = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: u
  };
  return O.forEach(Object.keys(e).concat(Object.keys(r)), function(y) {
    var c = f[y] || a, C = c(y);
    O.isUndefined(C) && c !== u || (n[y] = C);
  }), n;
}, Oe, ct;
function Vt() {
  return ct || (ct = 1, Oe = {
    version: "0.27.2"
  }), Oe;
}
var sn = Vt().version, A = z, je = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(t, e) {
  je[t] = function(n) {
    return typeof n === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
var lt = {};
je.transitional = function(e, r, n) {
  function s(a, i) {
    return "[Axios v" + sn + "] Transitional option '" + a + "'" + i + (n ? ". " + n : "");
  }
  return function(a, i, o) {
    if (e === !1)
      throw new A(
        s(i, " has been removed" + (r ? " in " + r : "")),
        A.ERR_DEPRECATED
      );
    return r && !lt[i] && (lt[i] = !0, console.warn(
      s(
        i,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(a, i, o) : !0;
  };
};
function an(t, e, r) {
  if (typeof t != "object")
    throw new A("options must be an object", A.ERR_BAD_OPTION_VALUE);
  for (var n = Object.keys(t), s = n.length; s-- > 0; ) {
    var a = n[s], i = e[a];
    if (i) {
      var o = t[a], u = o === void 0 || i(o, a, t);
      if (u !== !0)
        throw new A("option " + a + " must be " + u, A.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new A("Unknown option " + a, A.ERR_BAD_OPTION);
  }
}
var on = {
  assertOptions: an,
  validators: je
}, qt = g, un = At, dt = Ar, ht = nn, ce = Ft, cn = kt, Gt = on, G = Gt.validators;
function Y(t) {
  this.defaults = t, this.interceptors = {
    request: new dt(),
    response: new dt()
  };
}
Y.prototype.request = function(e, r) {
  typeof e == "string" ? (r = r || {}, r.url = e) : r = e || {}, r = ce(this.defaults, r), r.method ? r.method = r.method.toLowerCase() : this.defaults.method ? r.method = this.defaults.method.toLowerCase() : r.method = "get";
  var n = r.transitional;
  n !== void 0 && Gt.assertOptions(n, {
    silentJSONParsing: G.transitional(G.boolean),
    forcedJSONParsing: G.transitional(G.boolean),
    clarifyTimeoutError: G.transitional(G.boolean)
  }, !1);
  var s = [], a = !0;
  this.interceptors.request.forEach(function(C) {
    typeof C.runWhen == "function" && C.runWhen(r) === !1 || (a = a && C.synchronous, s.unshift(C.fulfilled, C.rejected));
  });
  var i = [];
  this.interceptors.response.forEach(function(C) {
    i.push(C.fulfilled, C.rejected);
  });
  var o;
  if (!a) {
    var u = [ht, void 0];
    for (Array.prototype.unshift.apply(u, s), u = u.concat(i), o = Promise.resolve(r); u.length; )
      o = o.then(u.shift(), u.shift());
    return o;
  }
  for (var f = r; s.length; ) {
    var l = s.shift(), y = s.shift();
    try {
      f = l(f);
    } catch (c) {
      y(c);
      break;
    }
  }
  try {
    o = ht(f);
  } catch (c) {
    return Promise.reject(c);
  }
  for (; i.length; )
    o = o.then(i.shift(), i.shift());
  return o;
};
Y.prototype.getUri = function(e) {
  e = ce(this.defaults, e);
  var r = cn(e.baseURL, e.url);
  return un(r, e.params, e.paramsSerializer);
};
qt.forEach(["delete", "get", "head", "options"], function(e) {
  Y.prototype[e] = function(r, n) {
    return this.request(ce(n || {}, {
      method: e,
      url: r,
      data: (n || {}).data
    }));
  };
});
qt.forEach(["post", "put", "patch"], function(e) {
  function r(n) {
    return function(a, i, o) {
      return this.request(ce(o || {}, {
        method: e,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: i
      }));
    };
  }
  Y.prototype[e] = r(), Y.prototype[e + "Form"] = r(!0);
});
var ln = Y, Ie, ft;
function dn() {
  if (ft) return Ie;
  ft = 1;
  var t = oe();
  function e(r) {
    if (typeof r != "function")
      throw new TypeError("executor must be a function.");
    var n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    var s = this;
    this.promise.then(function(a) {
      if (s._listeners) {
        var i, o = s._listeners.length;
        for (i = 0; i < o; i++)
          s._listeners[i](a);
        s._listeners = null;
      }
    }), this.promise.then = function(a) {
      var i, o = new Promise(function(u) {
        s.subscribe(u), i = u;
      }).then(a);
      return o.cancel = function() {
        s.unsubscribe(i);
      }, o;
    }, r(function(i) {
      s.reason || (s.reason = new t(i), n(s.reason));
    });
  }
  return e.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, e.prototype.subscribe = function(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }, e.prototype.unsubscribe = function(n) {
    if (this._listeners) {
      var s = this._listeners.indexOf(n);
      s !== -1 && this._listeners.splice(s, 1);
    }
  }, e.source = function() {
    var n, s = new e(function(i) {
      n = i;
    });
    return {
      token: s,
      cancel: n
    };
  }, Ie = e, Ie;
}
var be, pt;
function hn() {
  return pt || (pt = 1, be = function(e) {
    return function(n) {
      return e.apply(null, n);
    };
  }), be;
}
var Te, mt;
function fn() {
  if (mt) return Te;
  mt = 1;
  var t = g;
  return Te = function(r) {
    return t.isObject(r) && r.isAxiosError === !0;
  }, Te;
}
var yt = g, pn = Pt, re = ln, mn = Ft, yn = ke;
function Mt(t) {
  var e = new re(t), r = pn(re.prototype.request, e);
  return yt.extend(r, re.prototype, e), yt.extend(r, e), r.create = function(s) {
    return Mt(mn(t, s));
  }, r;
}
var w = Mt(yn);
w.Axios = re;
w.CanceledError = oe();
w.CancelToken = dn();
w.isCancel = jt();
w.VERSION = Vt().version;
w.toFormData = xt;
w.AxiosError = z;
w.Cancel = w.CanceledError;
w.all = function(e) {
  return Promise.all(e);
};
w.spread = hn();
w.isAxiosError = fn();
Ae.exports = w;
Ae.exports.default = w;
var _n = Ae.exports, vn = _n;
const ne = /* @__PURE__ */ Ut(vn), En = /* @__PURE__ */ new Set([
  "ENOTFOUND",
  "ENETUNREACH",
  // SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
  "UNABLE_TO_GET_ISSUER_CERT",
  "UNABLE_TO_GET_CRL",
  "UNABLE_TO_DECRYPT_CERT_SIGNATURE",
  "UNABLE_TO_DECRYPT_CRL_SIGNATURE",
  "UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY",
  "CERT_SIGNATURE_FAILURE",
  "CRL_SIGNATURE_FAILURE",
  "CERT_NOT_YET_VALID",
  "CERT_HAS_EXPIRED",
  "CRL_NOT_YET_VALID",
  "CRL_HAS_EXPIRED",
  "ERROR_IN_CERT_NOT_BEFORE_FIELD",
  "ERROR_IN_CERT_NOT_AFTER_FIELD",
  "ERROR_IN_CRL_LAST_UPDATE_FIELD",
  "ERROR_IN_CRL_NEXT_UPDATE_FIELD",
  "OUT_OF_MEM",
  "DEPTH_ZERO_SELF_SIGNED_CERT",
  "SELF_SIGNED_CERT_IN_CHAIN",
  "UNABLE_TO_GET_ISSUER_CERT_LOCALLY",
  "UNABLE_TO_VERIFY_LEAF_SIGNATURE",
  "CERT_CHAIN_TOO_LONG",
  "CERT_REVOKED",
  "INVALID_CA",
  "PATH_LENGTH_EXCEEDED",
  "INVALID_PURPOSE",
  "CERT_UNTRUSTED",
  "CERT_REJECTED",
  "HOSTNAME_MISMATCH"
]);
var Rn = (t) => !En.has(t && t.code);
const gn = /* @__PURE__ */ Ut(Rn);
function _t(t, e, r, n, s, a, i) {
  try {
    var o = t[a](i), u = o.value;
  } catch (f) {
    r(f);
    return;
  }
  o.done ? e(u) : Promise.resolve(u).then(n, s);
}
function Ht(t) {
  return function() {
    var e = this, r = arguments;
    return new Promise(function(n, s) {
      var a = t.apply(e, r);
      function i(u) {
        _t(a, n, s, i, o, "next", u);
      }
      function o(u) {
        _t(a, n, s, i, o, "throw", u);
      }
      i(void 0);
    });
  };
}
function vt(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Et(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? vt(Object(r), !0).forEach(function(n) {
      Cn(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : vt(Object(r)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return t;
}
function Cn(t, e, r) {
  return e in t ? Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = r, t;
}
var Be = "axios-retry";
function Wt(t) {
  return !t.response && !!t.code && // Prevents retrying cancelled requests
  t.code !== "ECONNABORTED" && // Prevents retrying timed out requests
  gn(t);
}
var Yt = ["get", "head", "options"], wn = Yt.concat(["put", "delete"]);
function Fe(t) {
  return t.code !== "ECONNABORTED" && (!t.response || t.response.status >= 500 && t.response.status <= 599);
}
function On(t) {
  return t.config ? Fe(t) && Yt.indexOf(t.config.method) !== -1 : !1;
}
function zt(t) {
  return t.config ? Fe(t) && wn.indexOf(t.config.method) !== -1 : !1;
}
function Jt(t) {
  return Wt(t) || zt(t);
}
function In() {
  return 0;
}
function bn() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100, r = Math.pow(2, t) * e, n = r * 0.2 * Math.random();
  return r + n;
}
function Rt(t) {
  var e = t[Be] || {};
  return e.retryCount = e.retryCount || 0, t[Be] = e, e;
}
function Tn(t, e) {
  return Et(Et({}, e), t[Be]);
}
function Un(t, e) {
  t.defaults.agent === e.agent && delete e.agent, t.defaults.httpAgent === e.httpAgent && delete e.httpAgent, t.defaults.httpsAgent === e.httpsAgent && delete e.httpsAgent;
}
function Pn(t, e, r, n) {
  return Ne.apply(this, arguments);
}
function Ne() {
  return Ne = Ht(function* (t, e, r, n) {
    var s = r.retryCount < t && e(n);
    if (typeof s == "object")
      try {
        var a = yield s;
        return a !== !1;
      } catch {
        return !1;
      }
    return s;
  }), Ne.apply(this, arguments);
}
function k(t, e) {
  t.interceptors.request.use((r) => {
    var n = Rt(r);
    return n.lastRequestTime = Date.now(), r;
  }), t.interceptors.response.use(null, /* @__PURE__ */ function() {
    var r = Ht(function* (n) {
      var {
        config: s
      } = n;
      if (!s)
        return Promise.reject(n);
      var {
        retries: a = 3,
        retryCondition: i = Jt,
        retryDelay: o = In,
        shouldResetTimeout: u = !1,
        onRetry: f = () => {
        }
      } = Tn(s, e), l = Rt(s);
      if (yield Pn(a, i, l, n)) {
        l.retryCount += 1;
        var y = o(l.retryCount, n);
        if (Un(t, s), !u && s.timeout && l.lastRequestTime) {
          var c = Date.now() - l.lastRequestTime, C = s.timeout - c - y;
          if (C <= 0)
            return Promise.reject(n);
          s.timeout = C;
        }
        return s.transformRequest = [(J) => J], f(l.retryCount, n, s), new Promise((J) => setTimeout(() => J(t(s)), y));
      }
      return Promise.reject(n);
    });
    return function(n) {
      return r.apply(this, arguments);
    };
  }());
}
k.isNetworkError = Wt;
k.isSafeRequestError = On;
k.isIdempotentRequestError = zt;
k.isNetworkOrIdempotentRequestError = Jt;
k.exponentialDelay = bn;
k.isRetryableError = Fe;
var ee, Bn = new Uint8Array(16);
function Nn() {
  if (!ee && (ee = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !ee))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return ee(Bn);
}
const An = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function Ln(t) {
  return typeof t == "string" && An.test(t);
}
var R = [];
for (var Ue = 0; Ue < 256; ++Ue)
  R.push((Ue + 256).toString(16).substr(1));
function Sn(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (R[t[e + 0]] + R[t[e + 1]] + R[t[e + 2]] + R[t[e + 3]] + "-" + R[t[e + 4]] + R[t[e + 5]] + "-" + R[t[e + 6]] + R[t[e + 7]] + "-" + R[t[e + 8]] + R[t[e + 9]] + "-" + R[t[e + 10]] + R[t[e + 11]] + R[t[e + 12]] + R[t[e + 13]] + R[t[e + 14]] + R[t[e + 15]]).toLowerCase();
  if (!Ln(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
function Dn(t, e, r) {
  t = t || {};
  var n = t.random || (t.rng || Nn)();
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, Sn(n);
}
const $n = "https://store.xsolla.com/api/v2", xn = "https://store.xsolla.com/api/v3";
class kn extends Error {
  constructor({
    errorCode: e,
    errorMessage: r,
    statusCode: n
  }) {
    super(r), this.errorCode = e, this.statusCode = n;
  }
}
const h = (t) => {
  var r;
  const e = (r = t == null ? void 0 : t.response) == null ? void 0 : r.data;
  return Promise.reject(
    new kn({
      errorCode: (e == null ? void 0 : e.errorCode) || 0,
      errorMessage: (e == null ? void 0 : e.errorMessage) || JSON.stringify(t.toString()),
      statusCode: (e == null ? void 0 : e.statusCode) || 0
    })
  );
};
function jn(t) {
  return t.has_more;
}
function Fn(t) {
  return t.items;
}
const v = (t) => {
  const e = {
    "Content-Type": "application/json"
  };
  return t.auth ? { ...e, Authorization: `Bearer ${t.userToken}` } : e;
}, T = (t) => {
  const e = {
    "Content-Type": "application/json"
  };
  return t.auth ? { ...e, Authorization: `Bearer ${t.userToken}` } : {
    ...e,
    "x-unauthorized-id": t.xUnauthorizedId
  };
}, gt = (t, e) => {
  const r = {
    "Content-Type": "application/json"
  };
  return t.auth ? { ...r, Authorization: `Bearer ${t.userToken}` } : {
    ...r,
    "x-unauthorized-id": t.xUnauthorizedId,
    "x-user": btoa(JSON.stringify(e))
  };
}, m = class m {
  static set baseUrl(e) {
    this._baseUrl = e, this.instance.defaults.baseURL = e, this.instanceWithRetries.defaults.baseURL = e;
  }
  static getGamesList({ projectId: e, locale: r, offset: n = 0, limit: s, additionalFields: a }, i) {
    return this.instanceWithRetries.get(`/project/${e}/items/game`, {
      headers: v(i),
      params: { locale: r, offset: n, additional_fields: a, limit: s }
    }).then((o) => o.data).catch(h);
  }
  static getGameBySku({ projectId: e, itemSku: r, locale: n }) {
    return this.instance.get(`/project/${e}/items/game/sku/${r}`, {
      params: { locale: n }
    }).then((s) => s.data).catch(h);
  }
  static getAnyItemBySku({ projectId: e, itemSku: r, locale: n }, s) {
    return this.instance.get(
      `/project/${e}/items/sku/${r}`,
      {
        params: { locale: n },
        headers: v(s)
      }
    ).then((a) => a.data).catch(h);
  }
  static getVirtualItemsBySkus({
    projectId: e,
    itemsSkus: r,
    locale: n,
    offset: s,
    limit: a
  }, i) {
    const o = r.map((u) => `sku[]=${u}`).join("&");
    return this.instance.get(`/project/${e}/items?${o}`, {
      params: { locale: n, offset: s, limit: a },
      headers: v(i)
    }).then((u) => u.data).catch(h);
  }
  static getGamesBySkus({ projectId: e, itemsSkus: r, locale: n }, s) {
    const a = r.map((i) => `sku[]=${i}`).join("&");
    return this.instance.get(
      `/project/${e}/items/game?${a}`,
      {
        params: { locale: n },
        headers: v(s)
      }
    ).then((i) => i.data).catch(h);
  }
  static getAnyItems({ projectId: e, locale: r }, n) {
    return this.instance.get(`/project/${e}/items`, {
      params: {
        locale: r,
        headers: v(n)
      }
    }).then((s) => s.data).catch(h);
  }
  static getBundlesList({
    projectId: e,
    locale: r,
    offset: n = 0,
    limit: s,
    promocode: a,
    additionalFields: i
  }, o) {
    return this.instanceWithRetries.get(`/project/${e}/items/bundle`, {
      headers: v(o),
      params: {
        locale: r,
        offset: n,
        limit: s,
        promo_code: a,
        additional_fields: i
      }
    }).then((u) => u.data).catch(h);
  }
  static getBundlesByGroup({
    projectId: e,
    groupId: r,
    locale: n,
    offset: s,
    limit: a,
    promocode: i,
    additionalFields: o
  }, u) {
    return this.instanceWithRetries.get(
      `/project/${e}/items/bundle/group/${r}`,
      {
        headers: v(u),
        params: {
          locale: n,
          offset: s,
          limit: a,
          promo_code: i,
          additional_fields: o
        }
      }
    ).then((f) => f.data).catch(h);
  }
  static getBundleBySku({ projectId: e, itemSku: r, locale: n }) {
    return this.instance.get(`/project/${e}/items/bundle/sku/${r}`, {
      params: { locale: n }
    }).then((s) => s.data).catch(h);
  }
  static getVirtualCurrencyList({ projectId: e, locale: r, limit: n, offset: s, additionalFields: a }, i) {
    return this.instance.get(
      `/project/${e}/items/virtual_currency`,
      {
        headers: v(i),
        params: {
          locale: r,
          offset: s,
          limit: n,
          additional_fields: a
        }
      }
    ).then((o) => o.data).catch(h);
  }
  static getVirtualCurrencyPackage({
    projectId: e,
    locale: r,
    offset: n,
    limit: s,
    promocode: a,
    additionalFields: i
  }, o) {
    return this.instanceWithRetries.get(
      `/project/${e}/items/virtual_currency/package`,
      {
        headers: v(o),
        params: {
          locale: r,
          offset: n,
          limit: s,
          promo_code: a,
          additional_fields: i
        }
      }
    ).then((u) => u.data).catch(h);
  }
  static getVirtualCurrencyPackageBySku({
    projectId: e,
    itemSku: r,
    locale: n
  }) {
    return this.instanceWithRetries.get(
      `/project/${e}/items/virtual_currency/package/sku/${r}`,
      { params: { locale: n } }
    ).then((s) => s.data).catch(h);
  }
  static getVirtualItems({ projectId: e, locale: r, offset: n, limit: s, additionalFields: a }, i) {
    return this.instanceWithRetries.get(
      `/project/${e}/items/virtual_items`,
      {
        headers: v(i),
        params: {
          locale: r,
          offset: n,
          limit: s,
          additional_fields: a
        }
      }
    ).then((o) => o.data).catch(h);
  }
  static getVirtualItemsByGroup({
    projectId: e,
    groupId: r,
    locale: n,
    offset: s,
    limit: a,
    promocode: i,
    additionalFields: o
  }, u) {
    return this.instanceWithRetries.get(
      `/project/${e}/items/virtual_items/group/${r}`,
      {
        headers: v(u),
        params: {
          locale: n,
          offset: s,
          limit: a,
          promo_code: i,
          additional_fields: o
        }
      }
    ).then((f) => f.data).catch(h);
  }
  static getBatchVirtualItemGroups({
    projectId: e,
    groupIds: r,
    locale: n,
    offset: s,
    limit: a,
    promocode: i,
    additionalFields: o
  }, u) {
    return this.instanceWithRetries.get(
      `/project/${e}/items/virtual_items/group?${r.map((f) => `external_id[]=${f}`).join("&")}`,
      {
        headers: v(u),
        params: {
          locale: n,
          offset: s,
          limit: a,
          promo_code: i,
          additional_fields: o
        }
      }
    ).then((f) => f.data).catch(h);
  }
  static getGroups({ projectId: e, locale: r }) {
    return this.instanceWithRetries.get(`/project/${e}/items/groups`, {
      params: { locale: r }
    }).then((n) => n.data).catch(h);
  }
  static getGroupAdmin({ projectId: e, groupId: r, locale: n }) {
    return this.instanceWithRetries.get(
      `/project/${e}/admin/items/virtual_items/groups/${r}`,
      {
        params: { locale: n }
      }
    ).then((s) => s.data).catch(h);
  }
  static getVirtualItemBySku({ projectId: e, itemSku: r, locale: n }) {
    return this.instance.get(
      `/project/${e}/items/virtual_items/sku/${r}`,
      { params: { locale: n } }
    ).then((s) => s.data).catch(h);
  }
  static createTokenByItem({
    projectId: e,
    itemSku: r,
    auth: n,
    body: s
  }) {
    return this.instanceWithRetries.post(
      `/project/${e}/payment/item/${r}`,
      { ...s },
      { headers: v(n) }
    ).then((a) => a.data).catch(h);
  }
  static createOrderForVirtualCurrency({
    projectId: e,
    itemSku: r,
    vcSku: n,
    userToken: s,
    custom_parameters: a
  }) {
    return this.instanceWithRetries.post(
      `project/${e}/payment/item/${r}/virtual/${n}`,
      {
        custom_parameters: a
      },
      {
        headers: v({ auth: !0, userToken: s })
      }
    ).then((i) => i.data).catch(h);
  }
  static createOrderWithFreeItem({
    projectId: e,
    itemSku: r,
    userToken: n,
    custom_parameters: s
  }) {
    return this.instanceWithRetries.post(
      `/project/${e}/free/item/${r}`,
      {
        custom_parameters: s
      },
      {
        headers: v({ auth: !0, userToken: n })
      }
    ).then((a) => a.data).catch(h);
  }
  // Rewards
  static getAdminRewardChains({
    projectId: e,
    partnerToken: r
  }) {
    return this.instance.get(
      `/project/${e}/admin/reward_chain`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${r}`
        }
      }
    ).then((n) => n.data).catch(h);
  }
  static getCurrentUserRewardChains({
    projectId: e,
    userToken: r,
    locale: n
  }) {
    const s = r ? { auth: !0, userToken: r } : { auth: !1, xUnauthorizedId: Dn() };
    return this.instance.get(
      `/project/${e}/user/reward_chain?locale=${n}`,
      {
        headers: v(s)
      }
    ).then((a) => a.data).catch(h);
  }
  static getCurrentUserValuePointBalance({
    projectId: e,
    rewardChainId: r,
    userToken: n,
    locale: s
  }) {
    return this.instanceWithRetries.get(
      `project/${e}/user/reward_chain/${r}/balance?locale=${s}`,
      {
        headers: v({ auth: !0, userToken: n })
      }
    ).then((a) => a.data).catch(h);
  }
  static claimRewardChainStep({
    projectId: e,
    rewardChainId: r,
    stepId: n,
    userToken: s
  }) {
    return this.instance.post(
      `/project/${e}/user/reward_chain/${r}/step/${n}/claim`,
      {},
      {
        headers: v({ auth: !0, userToken: s })
      }
    ).then((a) => a.data).catch(h);
  }
  static updateUserClan({
    projectId: e,
    userToken: r
  }) {
    return this.instance.put(
      `/project/${e}/user/clan/update`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${r}`
        }
      }
    ).then((n) => n.data).catch(h);
  }
  // Promocodes
  static verifyPromocode({
    projectId: e,
    promocode: r,
    userToken: n,
    locale: s
  }) {
    return this.instance.get(
      `/project/${e}/promotion/code/${r}/verify?locale=${s}`,
      { headers: v({ auth: !0, userToken: n }) }
    ).then((a) => a.data).catch(h);
  }
  static getPromocodeRewards({
    projectId: e,
    promocode: r,
    auth: n,
    locale: s
  }) {
    return this.instance.get(
      `/project/${e}/promotion/code/${r}/verify`,
      {
        headers: v(n),
        params: { locale: s }
      }
    ).then((a) => a.data).catch(h);
  }
  static redeemPromocode({
    projectId: e,
    auth: r,
    locale: n,
    body: s
  }) {
    return this.instance.post(`/project/${e}/promocode/redeem`, s, {
      headers: v(r),
      params: { locale: n }
    }).then((a) => a.data).catch(h);
  }
  static cancelPromocode({
    projectId: e,
    auth: r,
    locale: n,
    body: s
  }) {
    return this.instance.put(`/project/${e}/promocode/remove`, s, {
      headers: v(r),
      params: { locale: n }
    }).then((a) => a.data).catch(h);
  }
  static redeemCoupon({
    projectId: e,
    couponCode: r,
    userToken: n,
    locale: s
  }) {
    return this.instance.post(
      `/project/${e}/coupon/redeem`,
      {
        coupon_code: r
      },
      {
        headers: v({ auth: !0, userToken: n }),
        params: { locale: s }
      }
    ).then((a) => a.data).catch(h);
  }
  static createTokenByCart({
    projectId: e,
    cartId: r,
    body: n,
    auth: s,
    xUser: a
  }) {
    return this.instance.post(
      `/project/${e}/payment/cart/${r}`,
      n,
      {
        headers: gt(s, a)
      }
    ).then((i) => i.data).catch(h);
  }
};
m._baseUrl = $n, m.instance = ne.create({ baseURL: m._baseUrl }), m.instanceV3 = ne.create({ baseURL: xn }), m.instanceWithRetries = ne.create({ baseURL: m._baseUrl }), m.initRetries = ({ retries: e = 0, retryDelay: r = 1e3 }) => {
  e !== 0 && k(m.instanceWithRetries, {
    retries: e,
    retryDelay: () => r,
    retryCondition: (n) => {
      var s;
      return ((s = n == null ? void 0 : n.response) == null ? void 0 : s.status) === 429;
    }
  });
}, m.getCartById = ({
  projectId: e,
  cartId: r,
  locale: n,
  currency: s,
  auth: a
}) => m.instance.get(`/project/${e}/cart/${r}`, {
  params: {
    currency: s,
    locale: n
  },
  headers: T(a)
}).then((i) => i.data).catch(h), m.getUserCart = ({
  projectId: e,
  currency: r,
  locale: n,
  auth: s
}) => m.instance.get(`/project/${e}/cart`, {
  params: {
    currency: r,
    locale: n
  },
  headers: T(s)
}).then((a) => a.data).catch(h), m.cartClearById = ({
  projectId: e,
  cartId: r,
  auth: n
}) => m.instance.put(`/project/${e}/cart/${r}/clear`, void 0, {
  headers: T(n)
}).catch(h), m.cartClear = ({
  projectId: e,
  auth: r
}) => m.instance.put(`/project/${e}/cart/clear`, void 0, {
  headers: T(r)
}).catch(h), m.cartFill = ({
  projectId: e,
  body: r,
  auth: n
}) => m.instance.put(`/project/${e}/cart/fill`, r, {
  headers: T(n)
}).then((s) => s.data).catch(h), m.cartFillById = ({
  projectId: e,
  cartId: r,
  body: n,
  auth: s,
  locale: a
}) => m.instance.put(`/project/${e}/cart/${r}/fill`, n, {
  headers: T(s),
  params: { locale: a }
}).then((i) => i.data).catch(h), m.putItemByCartId = ({
  projectId: e,
  cartId: r,
  body: n,
  itemSku: s,
  auth: a
}) => m.instance.put(`/project/${e}/cart/${r}/item/${s}`, n, {
  headers: T(a)
}).catch(h), m.deleteV2ItemByCartId = ({
  projectId: e,
  cartId: r,
  itemSku: n,
  auth: s
}) => m.instance.delete(
  `/project/${e}/cart/${r}/item/${n}`,
  {
    headers: T(s)
  }
), m.deleteV3ItemByCartId = ({
  projectId: e,
  cartId: r,
  itemSku: n,
  auth: s,
  locale: a
}) => m.instanceV3.delete(`/project/${e}/cart/${r}/item/${n}`, {
  headers: T(s),
  params: { locale: a }
}).then((i) => i.data).catch(h), m.putItem = ({
  projectId: e,
  itemSku: r,
  body: n,
  auth: s
}) => m.instance.put(`/project/${e}/cart/item/${r}`, n, {
  headers: T(s)
}).catch(h), m.deleteItem = ({
  projectId: e,
  itemSku: r,
  auth: n
}) => m.instance.delete(`/project/${e}/cart/item/${r}`, {
  headers: T(n)
}).catch(h), m.createOrderForFreeCart = ({
  projectId: e,
  auth: r,
  currency: n,
  locale: s,
  cartId: a,
  xUser: i,
  customParameters: o
}) => m.instance.post(
  `/project/${e}/free/cart/${a}`,
  {
    currency: n,
    locale: s,
    custom_parameters: o
  },
  {
    headers: gt(r, i)
  }
).catch(h);
let d = m;
const P = class P {
  static getVirtualItemsByGroup({
    locale: e,
    groupId: r
  }) {
    return this.getDemoData(e).then((n) => n[r]);
  }
};
P.instance = ne.create({ baseURL: "/api" }), P.cachedDemoData = null, P.getDemoData = (e = "en") => (P.cachedDemoData || (P.cachedDemoData = P.instance.get("/demo-store-items").then((r) => r.data.url).then((r) => P.instance.get(r)).then((r) => r.data).catch(h)), P.cachedDemoData.then((r) => r[e]));
let ae = P;
var _ = /* @__PURE__ */ ((t) => (t.BUNDLE = "bundle", t.GAME_KEY = "game_key", t.PHYSICAL_GOOD = "physical_good", t.UNIT = "unit", t.VIRTUAL_CURRENCY = "virtual_currency", t.VIRTUAL_GOOD = "virtual_good", t.DIGITAL_CONTENT = "digital_content", t))(_ || {});
const Vn = (t) => ({
  externalId: t.external_id,
  value: t.value
}), Kt = (t) => ({
  externalId: t.external_id,
  name: t.name,
  values: t.values.map(Vn)
}), Xt = (t) => ({
  externalId: t.external_id,
  name: t.name
}), Qt = (t) => ({
  intervalType: t.interval_type,
  resetNextDate: new Date(
    t.reset_next_date * 1e3
  ).toISOString(),
  dayOfMonth: t.day_of_month,
  dayOfWeek: t.day_of_week,
  displayableResetStartDate: t.displayable_reset_start_date,
  displayableResetNextDate: t.displayable_reset_next_date,
  time: t.time
}), Ct = (t) => ({
  available: t.available,
  total: t.total,
  recurrentSchedule: t.recurrent_schedule ? Qt(t.recurrent_schedule) : null
}), Zt = (t) => {
  if (!t)
    return null;
  const e = { perUser: null, perItem: null }, { per_item: r, per_user: n } = t;
  return r && (e.perItem = Ct(r)), n && (e.perUser = Ct(n)), e;
}, er = (t) => ({
  dateFrom: t.date_from,
  dateUntil: t.date_until
}), qn = (t) => ({
  amount: t.amount,
  amountWithoutDiscount: t.amount_without_discount,
  currency: t.currency
}), Gn = (t) => ({
  amount: t.amount,
  amountWithoutDiscount: t.amount_without_discount,
  calculatedPrice: {
    amount: t.calculated_price.amount,
    amountWithoutDiscount: t.calculated_price.amount_without_discount
  },
  description: t.description,
  imageUrl: t.image_url,
  isDefault: t.is_default,
  name: t.name,
  sku: t.sku,
  type: _.VIRTUAL_CURRENCY
}), tr = (t) => t.sort(
  (e, r) => new Date(e.dateEnd) > new Date(r.dateEnd) ? 1 : -1
), Mn = (t) => ({
  sku: t.sku,
  quantity: t.quantity,
  name: t.name,
  imageUrl: t.image_url,
  type: t.type,
  bundleType: t.bundle_type
}), Ve = (t) => t.map((e) => ({
  type: e.type,
  name: e.name,
  dateStart: e.date_start,
  dateEnd: e.date_end,
  discount: e.discount,
  bonus: e.bonus.map(Mn),
  limits: Zt(e.limits)
})), rr = (t) => ({
  itemId: t.item_id,
  imageUrl: t.image_url,
  sku: t.sku,
  amount: t.amount,
  name: t.name,
  isClan: t.is_clan || !1
});
class Z {
  constructor(e) {
    this.sku = e.sku, this.name = e.name, this.type = e.type, this.description = e == null ? void 0 : e.description, this.isFree = e.is_free, this.imageUrl = e.image_url, this.price = e.price ? qn(e.price) : null, this.virtualPrices = e.virtual_prices ? e.virtual_prices.map(Gn) : null, this.attributes = e.attributes ? e.attributes.map(Kt) : [], this.canBeBought = "can_be_bought" in e ? e.can_be_bought : !0, this.groups = e.groups ? e.groups.map(Xt) : [], this.promotions = e.promotions ? tr(Ve(e.promotions)) : [], "limits" in e && (this.limits = Zt(e.limits)), this.periods = e.periods ? e.periods.map(er) : [], "vp_rewards" in e && (this.vpRewards = e.vp_rewards ? e.vp_rewards.map(rr) : []), this.longDescription = e.long_description || null, this.customAttributes = e.custom_attributes || null;
  }
  get isAbleToBuyForRealPrice() {
    return this.price !== null;
  }
  get hasVirtualPrice() {
    return !!(this.virtualPrices && this.virtualPrices.length !== 0);
  }
  getVirtualPrice() {
    var e;
    return this.virtualPrices ? ((e = this.virtualPrices) == null ? void 0 : e.find((r) => r.isDefault)) || this.virtualPrices[0] : null;
  }
  getBonusItems() {
    return this.promotions.reduce(
      (e, r) => [
        ...e,
        ...r.bonus
      ],
      []
    );
  }
}
var $ = /* @__PURE__ */ ((t) => (t.STANDARD = "standard", t.VIRTUAL_CURRENCY_PACK = "virtual_currency_package", t))($ || {});
class qe extends Z {
  constructor(e) {
    super(e), this.type = _.GAME_KEY, this.drmSku = e.drm_sku, this.drmName = e.drm_name, this.isPreOrder = e.is_pre_order, this.releaseDate = e.release_date, this.isFree = e.is_free, this.hasKeys = e.has_keys, this.canBeBought = (e.has_keys || e.is_pre_order) && e.can_be_bought, this.promotions = e.promotions ? tr(Ve([...e.promotions])) : [];
  }
}
class M {
  constructor(e) {
    var r, n;
    this.type = _.UNIT, this.isFree = !1, this.virtualPrices = null, this.attributes = [], this.canBeBought = !0, this.groups = [], this.isAbleToBuyForRealPrice = !0, this.hasVirtualPrice = !1, this.sku = e.sku, this.name = e.name, this.description = e.description, this.imageUrl = e.image_url, this.longDescription = e.long_description || null, this.customAttributes = e.custom_attributes || null, this.attributes = (r = e.attributes) == null ? void 0 : r.map(Kt), this.groups = (n = e.groups) == null ? void 0 : n.map(Xt), this.unitItems = e.unit_items.map(
      (s) => new qe({
        ...s,
        name: e.name,
        description: e.description,
        image_url: e.image_url,
        attributes: e.attributes,
        groups: e.groups
      })
    ), [this.displayedUnitItem] = this.unitItems.sort(
      (s, a) => {
        var i, o;
        return Number((i = s.price) == null ? void 0 : i.amount) - Number((o = a.price) == null ? void 0 : o.amount);
      }
    ), this.periods = e.periods ? e.periods.map(er) : [], this.vpRewards = e.vp_rewards ? e.vp_rewards.map(rr) : [], this.canBeBought = !!e.unit_items.filter(
      ({ can_be_bought: s, has_keys: a, is_pre_order: i }) => (a || i) && s
    ).length, this.isFree = this.unitItems.every((s) => s.isFree);
  }
  getVirtualPrice() {
    return this.virtualPrices;
  }
  /**
   * Price of the displayedUnitItem, aka smallest price
   */
  get price() {
    return this.displayedUnitItem.price;
  }
  get promotions() {
    return this.displayedUnitItem.promotions;
  }
  hasGame(e) {
    return !!this.unitItems.find((r) => r.sku === e.sku);
  }
  getBonusItems() {
    return this.promotions.reduce(
      (e, r) => [
        ...e,
        ...r.bonus
      ],
      []
    );
  }
}
class Hn {
  constructor(e, r) {
    this.originalItem = e, this.quantity = r;
  }
}
const nr = (t) => ({
  consumable: t.consumable ? {
    usagesCount: t.consumable.usages_count
  } : null,
  expirationPeriod: t.expiration_period
});
class Ge extends Z {
  constructor(e) {
    super(e), this.type = _.VIRTUAL_CURRENCY, this.inventoryOptions = e.inventory_options ? nr(e.inventory_options) : null;
  }
}
class H extends Z {
  constructor(e) {
    super(e), this.type = _.BUNDLE, this.bundleType = $.VIRTUAL_CURRENCY_PACK, this.content = e.content.map(
      (r) => new Hn(new Ge(r), r.quantity)
    );
  }
}
class N extends Z {
  constructor(e) {
    super(e), this.type = _.VIRTUAL_GOOD, this.virtualType = e.virtual_item_type, this.inventoryOptions = e.inventory_options ? nr(e.inventory_options) : null;
  }
}
function sr(t) {
  switch (t.type) {
    case _.UNIT:
      return new M(t);
    case _.GAME_KEY:
      return new qe(t);
    case _.VIRTUAL_CURRENCY:
      return new Ge(t);
    case _.BUNDLE:
      return t.bundle_type === $.STANDARD ? new D(t) : new H(t);
    case _.VIRTUAL_GOOD:
      return new N(t);
    default:
      throw new Error("Unknown store item type");
  }
}
function wt(t) {
  return !!t;
}
class Wn {
  constructor(e, r) {
    this.originalItem = e, this.quantity = r;
  }
}
class D extends Z {
  constructor(e) {
    super(e), this.type = _.BUNDLE, this.bundleType = $.STANDARD, this.content = e.content.map((r) => new Wn(sr(r), r.quantity));
  }
}
class Me {
  constructor(e) {
    this.externalId = e.external_id, this.name = e.name, this.description = e.description, this.imageUrl = e.image_url, this.level = e.level, this.order = e.order, this.children = e.children.map((r) => new Me(r)), this.parentExternalId = e.parent_external_id;
  }
}
const Yn = (t) => ({
  amount: t.amount,
  amountWithoutDiscount: t.amount_without_discount,
  currency: t.currency
}), zn = (t) => {
  const e = t.quantity ?? 0, r = t.is_bonus ?? !1;
  return {
    quantity: e,
    isBonus: r,
    item: sr(t),
    isDuplication: !1,
    hasDuplicates: !1
  };
}, Jn = (t) => t.map((e) => {
  var r, n, s, a;
  return {
    errorCode: e.errorCode,
    errorMessage: e.errorMessage,
    item: {
      sku: e.item.sku,
      quantity: e.item.quantity,
      name: (r = e.item) == null ? void 0 : r.name,
      description: (n = e.item) == null ? void 0 : n.description,
      imageUrl: (s = e.item) == null ? void 0 : s.image_url,
      bundleType: (a = e.item) == null ? void 0 : a.bundle_type
    }
  };
}), Kn = (t) => [
  _.UNIT,
  _.GAME_KEY,
  _.VIRTUAL_CURRENCY,
  _.BUNDLE,
  _.VIRTUAL_GOOD
].includes(t.type), S = (t) => ({
  cartId: t.cart_id,
  price: t.price ? Yn(t.price) : null,
  isFree: t.is_free,
  items: t.items ? t.items.filter(Kn).map(zn) : [],
  promotions: Ve(t.promotions ?? []),
  warnings: Jn(t.warnings ?? [])
}), Xn = (t) => ({
  sku: t.sku,
  name: t.name,
  type: t.type,
  description: t.description,
  imageUrl: t.image_url,
  quantity: t.quantity,
  isFree: t.is_free
}), Ot = (t) => ({
  itemId: t.item_id,
  sku: t.sku,
  type: t.type,
  name: t.name,
  description: t.description,
  imageUrl: t.image_url,
  drmName: t.drm_name,
  drmSku: t.drm_sku,
  virtualItemType: t.virtual_item_type,
  bundleType: t.bundle_type
}), Qn = (t) => {
  var e, r;
  return {
    bonus: ((e = t.bonus) == null ? void 0 : e.map((n) => ({
      ...Ot(n.item),
      quantity: n.quantity
    }))) || [],
    discount: t == null ? void 0 : t.discount,
    discountedItems: ((r = t == null ? void 0 : t.discounted_items) == null ? void 0 : r.map((n) => ({
      ...Ot(n),
      discount: n.discount
    }))) || [],
    isSelectable: t.is_selectable
  };
}, It = (t) => ({
  type: t.type,
  code: t.code,
  reward: Qn(t.reward)
}), ar = (t) => ({
  sku: t.sku,
  name: t.name,
  type: t.type,
  bundleType: t.bundle_type,
  description: t.description,
  imageUrl: t.image_url,
  quantity: t.quantity
}), Zn = (t) => ({
  reward: t.reward.map(ar)
}), es = (t) => ({
  stepId: t.step_id,
  name: t.name,
  isClaimed: t.is_claimed,
  price: t.price,
  reward: t.reward.map(ar)
}), ir = (t) => ({
  sku: t.sku,
  name: t.name,
  imageUrl: t.image_url,
  description: t.description,
  longDescription: t.long_description,
  amount: t.amount,
  isClan: t.is_clan || !1
}), ts = (t) => ({
  rewardChainId: t.reward_chain_id,
  name: t.name,
  description: t.description,
  longDescription: t.long_description,
  imageUrl: t.image_url,
  order: t.order,
  dateStart: t.date_start,
  dateEnd: t.date_end,
  valuePoint: ir(t.value_point),
  steps: t.steps.map(es),
  recurrentSchedule: t.recurrent_schedule ? Qt(t.recurrent_schedule) : null,
  popupHeader: t.popup_header,
  popupImageUrl: t.popup_image_url,
  popupInstruction: t.popup_instruction,
  clanType: t.clan_type
}), bt = 50, B = (t) => (e) => e.map(t), U = class U {
  static initRetries({ retries: e = 0, retryDelay: r = 1e3 }) {
    e !== 0 && d.initRetries({ retries: e, retryDelay: r });
  }
  static async getRecursiveItems(e) {
    const r = [];
    let n = 0;
    for (; ; ) {
      const s = await e({
        limit: bt,
        offset: n
      }), a = Fn(s);
      if (r.push(...a), n += bt, !jn(s))
        return r;
    }
  }
  static async getVirtualCurrencies(e) {
    const { auth: r, ...n } = e;
    return this.getRecursiveItems(
      ({ offset: s, limit: a }) => d.getVirtualCurrencyList(
        {
          ...n,
          offset: s,
          limit: a
        },
        r
      )
    ).then(B((s) => new Ge(s)));
  }
  static async getVirtualCurrencyPacks(e) {
    const { auth: r, ...n } = e;
    return this.getRecursiveItems(
      ({ offset: s, limit: a }) => d.getVirtualCurrencyPackage(
        {
          ...n,
          offset: s,
          limit: a
        },
        r
      )
    ).then(B((s) => new H(s)));
  }
  static async getGames(e) {
    const { auth: r, ...n } = e;
    return this.getRecursiveItems(
      ({ offset: s, limit: a }) => d.getGamesList(
        {
          ...n,
          offset: s,
          limit: a
        },
        r
      )
    ).then(B((s) => new M(s)));
  }
  static async getVirtualItems(e) {
    const { auth: r, ...n } = e;
    return this.getRecursiveItems(
      ({ offset: s, limit: a }) => d.getVirtualItems({ ...n, offset: s, limit: a }, r)
    ).then(B((s) => new N(s)));
  }
  static async getVirtualItemsByGroup(e) {
    const { demo: r, auth: n, ...s } = e, a = r ? ae : d;
    return this.getRecursiveItems(
      ({ offset: i, limit: o }) => a.getVirtualItemsByGroup({ ...s, offset: i, limit: o }, n)
    ).then(B((i) => new N(i)));
  }
  static async getBatchVirtualItemGroups(e) {
    const { auth: r, groupIds: n, demoGroups: s, ...a } = e, i = n.filter(
      (l) => s.includes(l)
    ), o = n.filter(
      (l) => !s.includes(l)
    ), u = await this.getRecursiveItems(({ offset: l, limit: y }) => d.getBatchVirtualItemGroups(
      { groupIds: o, ...a, offset: l, limit: y },
      r
    )), f = (await Promise.all(
      i.map(
        (l) => this.getRecursiveItems(
          () => ae.getVirtualItemsByGroup({
            groupId: l,
            ...a
          })
        )
      )
    )).flat();
    return [...u, ...f].map((l) => new N(l));
  }
  static async getVirtualItemsBySkus(e) {
    const { auth: r, ...n } = e;
    return this.getRecursiveItems(
      ({ offset: s, limit: a }) => d.getVirtualItemsBySkus(
        {
          ...n,
          offset: s,
          limit: a
        },
        r
      )
    ).then(
      B((s) => {
        switch (s.type) {
          case _.BUNDLE:
            return s.bundle_type === $.STANDARD ? new D(s) : new H(s);
          case _.VIRTUAL_GOOD:
            return new N(s);
          default:
            return null;
        }
      })
    ).then((s) => s.filter(wt));
  }
  static async getGamesBySkus({
    projectId: e,
    itemsSkus: r,
    locale: n = U.defaultLocale,
    auth: s
  }) {
    return (await d.getGamesBySkus(
      {
        projectId: e,
        itemsSkus: r,
        locale: n
      },
      s
    )).items.map((i) => i.type !== _.UNIT ? null : new M(i)).filter(wt);
  }
  static async getGroups({
    projectId: e,
    locale: r = U.defaultLocale
  }) {
    return (await d.getGroups({
      projectId: e,
      locale: r
    })).groups.map((a) => new Me(a));
  }
  static async getBundles(e) {
    const { auth: r, ...n } = e;
    return this.getRecursiveItems(
      ({ offset: s, limit: a }) => d.getBundlesList({ ...n, offset: s, limit: a }, r)
    ).then(B((s) => new D(s)));
  }
  static async getBundlesByGroup(e) {
    const { auth: r, ...n } = e;
    return this.getRecursiveItems(
      ({ offset: s, limit: a }) => d.getBundlesByGroup({ ...n, offset: s, limit: a }, r)
    ).then(B((s) => new D(s)));
  }
  static async getGameBySku({
    projectId: e,
    itemSku: r,
    locale: n = U.defaultLocale
  }) {
    const s = await d.getGameBySku({
      projectId: e,
      itemSku: r,
      locale: n
    });
    return new M(s);
  }
  static async getAnyItemBySku({
    projectId: e,
    itemSku: r,
    locale: n = U.defaultLocale,
    auth: s
  }) {
    if (!r)
      throw new Error("Empty sku");
    const a = await d.getAnyItemBySku(
      {
        projectId: e,
        itemSku: r,
        locale: n
      },
      s
    );
    switch (a.type) {
      case _.UNIT:
        return new M(a);
      case _.BUNDLE:
        return a.bundle_type === $.STANDARD ? new D(a) : new H(a);
      case _.VIRTUAL_GOOD:
        return new N(a);
      default:
        throw new Error("Unknown item type");
    }
  }
  static async getAnyItems({
    projectId: e,
    locale: r = U.defaultLocale,
    auth: n
  }) {
    return (await d.getAnyItems(
      {
        projectId: e,
        locale: r
      },
      n
    )).items.map((a) => {
      switch (a.type) {
        case _.UNIT:
          return new M(a);
        case _.GAME_KEY:
          return new qe(a);
        case _.BUNDLE:
          return a.bundle_type === $.STANDARD ? new D(a) : new H(a);
        case _.VIRTUAL_GOOD:
          return new N(a);
        default:
          throw new Error("Unknown item type");
      }
    });
  }
  static async getVirtualItemBySku({
    projectId: e,
    itemSku: r,
    locale: n = U.defaultLocale
  }) {
    const s = await d.getVirtualItemBySku({
      projectId: e,
      itemSku: r,
      locale: n
    });
    return new N(s);
  }
  static async getVirtualCurrencyPackageBySku({
    projectId: e,
    itemSku: r,
    locale: n = U.defaultLocale
  }) {
    const s = await d.getVirtualCurrencyPackageBySku({
      projectId: e,
      itemSku: r,
      locale: n
    });
    return new H(s);
  }
  static async getBundleBySku({
    projectId: e,
    itemSku: r,
    locale: n = U.defaultLocale
  }) {
    const s = await d.getBundleBySku({
      projectId: e,
      itemSku: r,
      locale: n
    });
    return new D(s);
  }
  static async createOrderWithSpecifiedItem({
    projectId: e,
    itemSku: r,
    auth: n,
    body: s
  }) {
    return await d.createTokenByItem({
      projectId: e,
      itemSku: r,
      auth: n,
      body: s
    });
  }
  static async createOrderWithSpecifiedItemPurchasedByVirtualCurrency({
    projectId: e,
    itemSku: r,
    vcSku: n,
    userToken: s,
    custom_parameters: a
  }) {
    return await d.createOrderForVirtualCurrency({
      projectId: e,
      itemSku: r,
      vcSku: n,
      userToken: s,
      custom_parameters: a
    });
  }
  static async buyFreeItem({
    projectId: e,
    itemSku: r,
    userToken: n,
    custom_parameters: s
  }) {
    return await d.createOrderWithFreeItem({
      projectId: e,
      itemSku: r,
      userToken: n,
      custom_parameters: s
    });
  }
  static async getAdminRewardChains({
    projectId: e,
    partnerToken: r
  }) {
    return (await d.getAdminRewardChains({
      projectId: e,
      partnerToken: r
    })).items;
  }
  static async getCurrentUserRewardChains({
    projectId: e,
    userToken: r,
    locale: n
  }) {
    return (await d.getCurrentUserRewardChains({
      projectId: e,
      userToken: r,
      locale: n
    })).items.map(ts);
  }
  static async getCurrentUserValuePointBalance({
    projectId: e,
    rewardChainId: r,
    userToken: n,
    locale: s
  }) {
    const a = await d.getCurrentUserValuePointBalance({
      projectId: e,
      rewardChainId: r,
      userToken: n,
      locale: s
    });
    return ir(a);
  }
  static async claimRewardChainStep({
    projectId: e,
    rewardChainId: r,
    stepId: n,
    userToken: s
  }) {
    return d.claimRewardChainStep({
      projectId: e,
      rewardChainId: r,
      stepId: n,
      userToken: s
    });
  }
  static async updateUserClan({
    projectId: e,
    userToken: r
  }) {
    const n = await d.updateUserClan({
      projectId: e,
      userToken: r
    });
    return Zn(n);
  }
  static async verifyPromocode({
    projectId: e,
    promocode: r,
    userToken: n,
    locale: s
  }) {
    const a = await d.verifyPromocode({
      projectId: e,
      promocode: r,
      userToken: n,
      locale: s
    });
    return It(a);
  }
  static async getPromocodeRewards({
    projectId: e,
    promocode: r,
    auth: n,
    locale: s
  }) {
    const a = await d.getPromocodeRewards({
      projectId: e,
      promocode: r,
      auth: n,
      locale: s
    });
    return It(a).reward;
  }
  static async redeemPromocode({
    projectId: e,
    cartId: r,
    selectedUnitItems: n,
    promocode: s,
    auth: a,
    locale: i
  }) {
    let o = {
      coupon_code: s,
      cart: {
        id: r
      }
    };
    n && (o = {
      ...o,
      selected_unit_items: n
    });
    const u = await d.redeemPromocode({
      projectId: e,
      body: o,
      auth: a,
      locale: i
    });
    return S(u);
  }
  static async cancelPromocode({
    projectId: e,
    auth: r,
    locale: n,
    cartId: s
  }) {
    const a = await d.cancelPromocode({
      projectId: e,
      auth: r,
      locale: n,
      body: {
        cart: {
          id: s
        }
      }
    });
    return S(a);
  }
  static async redeemCoupon({
    projectId: e,
    couponCode: r,
    userToken: n,
    locale: s
  }) {
    return (await d.redeemCoupon({
      projectId: e,
      couponCode: r,
      userToken: n,
      locale: s
    })).items.map(Xn);
  }
  /**
   * @description Removes an item from the cart.
   * @summary Delete cart item from current cart
   */
  static async deleteItemFromCurrentCart({
    projectId: e,
    itemSku: r,
    auth: n
  }) {
    await d.deleteItem({
      projectId: e,
      itemSku: r,
      auth: n
    });
  }
  static async updateItemQuantityInCurrentCart({
    projectId: e,
    itemSku: r,
    quantity: n,
    auth: s
  }) {
    await d.putItem({
      projectId: e,
      itemSku: r,
      body: {
        quantity: n
      },
      auth: s
    });
  }
  static async deleteItemByCartId({
    projectId: e,
    cartId: r,
    itemSku: n,
    auth: s
  }) {
    await d.deleteV2ItemByCartId({
      projectId: e,
      cartId: r,
      itemSku: n,
      auth: s
    });
  }
  static async deleteItemByCartIdAndGetItems({
    projectId: e,
    cartId: r,
    itemSku: n,
    auth: s,
    locale: a
  }) {
    const i = await d.deleteV3ItemByCartId({
      projectId: e,
      cartId: r,
      itemSku: n,
      auth: s,
      locale: a
    });
    return S(i);
  }
  static async upsertItemByCartId({
    projectId: e,
    cartId: r,
    itemSku: n,
    quantity: s,
    auth: a
  }) {
    await d.putItemByCartId({
      projectId: e,
      cartId: r,
      itemSku: n,
      body: {
        quantity: s
      },
      auth: a
    });
  }
  static async addItemsToCartById({
    projectId: e,
    cartId: r,
    items: n,
    auth: s,
    locale: a
  }) {
    const i = await d.cartFillById({
      projectId: e,
      cartId: r,
      body: {
        items: n
      },
      auth: s,
      locale: a
    });
    return S(i);
  }
  static async addItemsToCurrentCart({
    projectId: e,
    items: r,
    auth: n
  }) {
    const s = await d.cartFill({
      projectId: e,
      body: {
        items: r
      },
      auth: n
    });
    return S(s);
  }
  static async clearCartById({
    projectId: e,
    cartId: r,
    auth: n
  }) {
    await d.cartClearById({
      projectId: e,
      cartId: r,
      auth: n
    });
  }
  static async clearCurrentCart({
    projectId: e,
    auth: r
  }) {
    await d.cartClear({
      projectId: e,
      auth: r
    });
  }
  static async getCartById({
    projectId: e,
    cartId: r,
    locale: n,
    currency: s,
    auth: a
  }) {
    const i = await d.getCartById({
      projectId: e,
      cartId: r,
      auth: a,
      currency: s,
      locale: n
    });
    return S(i);
  }
  static async getCurrentUserCart({
    projectId: e,
    locale: r,
    currency: n,
    auth: s
  }) {
    const a = await d.getUserCart({
      projectId: e,
      auth: s,
      currency: n,
      locale: r
    });
    return S(a);
  }
  static async createFreeCartOrder({
    projectId: e,
    locale: r,
    currency: n,
    auth: s,
    cartId: a,
    xUser: i,
    customParameters: o
  }) {
    return (await d.createOrderForFreeCart({
      cartId: a,
      projectId: e,
      auth: s,
      currency: n,
      locale: r,
      xUser: i,
      customParameters: o
    })).data.order_id;
  }
  static async createTokenByCart({
    projectId: e,
    auth: r,
    body: n,
    cartId: s,
    xUser: a
  }) {
    return await d.createTokenByCart({
      cartId: s,
      projectId: e,
      auth: r,
      body: n,
      xUser: a
    });
  }
};
U.defaultLocale = "en";
let Tt = U;
var rs = /* @__PURE__ */ ((t) => (t.CONSUMABLE = "consumable", t.NON_CONSUMABLE = "non_consumable", t.NON_RENEWING_SUBSCRIPTION = "non_renewing_subscription", t))(rs || {}), ns = /* @__PURE__ */ ((t) => (t.COUPON = "coupon", t.PROMOCODE = "promo_code", t.UNIQUE_OFFER = "unique_catalog_offer", t))(ns || {}), ss = /* @__PURE__ */ ((t) => (t.PROMOTION = "promotion", t.PROMO_CODE = "promo_code", t))(ss || {});
export {
  D as Bundle,
  Wn as BundleItem,
  $ as BundleType,
  qe as GameKey,
  Me as Group,
  _ as ItemType,
  ns as PromocodeType,
  ss as PromotionType,
  $n as STORE_API_URL,
  d as StoreApi,
  Tt as StoreDataService,
  ae as StoreDemoApi,
  M as Unit,
  Ge as VirtualCurrency,
  H as VirtualCurrencyPack,
  N as VirtualItem,
  rs as VirtualItemType,
  v as getHeaderForStore,
  zn as transformCartItem
};
